const initState = {
    isFetching: false
}

const driverReducer = (state = initState, action) => {
    switch (action.type) {
        case 'GET_DRIVER':
            return action.data;      

        case 'GET_DRIVER_FAILED':
            return action.data;    

        case 'DELETE_DRIVER':
            return action.data;      

        case 'DELETE_DRIVER_FAILED':
            return action.data;    

        case 'CREATING_DRIVER':
            return {
                ...action.data, 
                isFetching: true
            };

        case 'CREATE_DRIVER':
            return {
                ...action.data, 
                isFetching: false
            };

        case 'CREATE_DRIVER_FAILED':
            return {
                ...action.data, 
                isFetching: false
            };

        case 'UPDATING_DRIVER':
            return {
                ...action.data, 
                isFetching: true
            };

        case 'UPDATE_DRIVER':
            return {
                ...action.data, 
                isFetching: false
            };

        case 'UPDATE_DRIVER_FAILED':
            return {
                ...action.data, 
                isFetching: false
            };         

        default:
            return state;
    }
}

export default driverReducer;